export default state => {
  return state.shappy.user_info
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/getters/getShappyInfo.js